<div class="login">
  @if (isSSO) {
    <div class="sso">
      <div>
        @if (brand.brandingLoaded()) {
          <img
            class="amplify-image"
            alt="Amplify logo"
            [src]="brand.loginLogo()"
            (click)="forceNormalLogin()"
          />
        } @else {
          <div style="height: 125px"></div>
        }
      </div>
      <h2>You have been signed out</h2>
      <p>
        To sign in again, please use your
        @if (ssoPortalURL && ssoPortalAction === 'link') {
          <a href="{{ ssoPortalURL }}"> organisation's portal </a>
          <span>.</span>
        } @else {
          organisation's portal.
        }
      </p>
    </div>
  } @else {
    <amplify-authenticator [hideSignUp]="true">
      <ng-template amplifySlot="header">
        <div class="logo-wrapper">
          @if (brand.brandingLoaded()) {
            <img
              class="amplify-image"
              alt="Amplify logo"
              [src]="brand.loginLogo()"
            />
          } @else {
            <div style="height: 125px"></div>
          }
        </div>
      </ng-template>
      <ng-template amplifySlot="sign-in-header">
        <h3
          class="amplify-heading"
          style="
            padding: var(--amplify-space-xl) 0 0 var(--amplify-space-xl);
            font-weight: bold;
          "
        >
          Sign in to your account
        </h3>
        <p
          class="amplify-heading"
          style="
            padding: 0 var(--amplify-space-xl) 0 var(--amplify-space-xl);
            color: var(--amplify-colors-neutral-60);
          "
        >
          To sign in via an institutional account, please use your
          organisation's portal.
        </p>
      </ng-template>

      <ng-template amplifySlot="confirm-reset-password-footer">
        <div>
          Passwords must be at least 16 characters long, containing at least 1
          number, 1 special character, 1 uppercase letter and 1 lowercase
          letter.
        </div>
      </ng-template>
    </amplify-authenticator>
  }

  @if (brand.brandingLoaded() && showDisclaimer) {
    <div [innerHTML]="brand.disclaimer()"></div>
  }
</div>
